export default __webpack_public_path__ + "static/media/makro.6e3b82b7.png";